var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height register-step-one"},[_c('v-col',{attrs:{"cols":"12"}},[_c('register-form-step-one',{on:{"next":_vm.goToStepTwo}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('help-button',{on:{"help":_vm.goToHelp}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }